import { useState, useEffect, useRef, useCallback } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export const useCountdown = (initialSeconds: number = 180) => {
    const [remainingTime, setRemainingTime] = useState('03:00');
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const endTimeRef = useRef<dayjs.Dayjs | null>(null);

    const start = useCallback(() => {
        const now = dayjs();
        const endTime = now.add(initialSeconds, 'second');
        endTimeRef.current = endTime;

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(() => {
            const now = dayjs();
            const diff = endTime.diff(now, 'second');
            if (diff <= 0) {
                setRemainingTime('00:00');
                clearInterval(intervalRef.current!);
            } else {
                const minutes = Math.floor(diff / 60);
                const seconds = diff % 60;
                const formatted = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                setRemainingTime(formatted);
            }
        }, 1000);
    }, [initialSeconds]);

    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    return { remainingTime, start };
};
